import store from '@/store/store.examiner'
import { parseJSON } from '@/utils/utils.store'

export const checkAuth = () => {
  return new Promise((resolve) => {
    if (store.getters.loggedIn) return resolve(true)

    const storageAccessToken = localStorage.getItem('access')
    const storageRefreshToken = localStorage.getItem('refresh')
    const access = parseJSON(storageAccessToken)
    const refresh = parseJSON(storageRefreshToken)

    if (access && refresh) {
      store.commit('setRefreshToken', refresh)
      store.commit('setToken', access)
      store.commit('setLoggingIn', true)

      return store.dispatch('fetchUser')
        .then(user => {
          if (user) {
            store.commit('setUser', user)
            store.commit('setLoggingIn', false)
            return resolve(true)
          }
        })
        .catch(error => {
          console.debug('refresh/login failure at utils.store.js:38', error)
          store.commit('setRefreshToken', null)
          store.commit('setToken', null)
          store.commit('setLoggingIn', false)
          return resolve(false)
        })
    }
    resolve(false)
  })
}
